import { computed, inject, Injectable, Signal } from '@angular/core';
import { ApiService } from './api.service';
import { Unit } from '@kinomap-dev/ng-ui-lib/core';
import { HttpResourceRef } from '@angular/common/http';
import { phpToAngularDateFormat } from '../utils/php-to-angular-date-format';

const DEFAULT_DATE_FORMAT: string = 'dd/MM/y HH:mm';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private readonly apiService: ApiService = inject(ApiService);
  private settingsRessources: HttpResourceRef<any | undefined> = this.apiService.getSettingsRessources;

  private readonly settingsSignal: Signal<any | undefined> = this.settingsRessources.value;

  public timezone: Signal<string> = computed(() => this.settingsSignal().timezone);
  public timezone_offset: Signal<string> = computed(() => this.settingsSignal().timezone_offset);

  get settings(): Signal<any> {
    return this.settingsSignal();
  }

  get unit(): Signal<Unit> {
    return computed(() => this.settingsSignal()?.unit || 'metric');
  }

  get dateDisplay(): Signal<string> {
    return computed(() => {
      const phpFormat: string | undefined = this.settingsSignal()?.default_date_format;
      return phpFormat ? phpToAngularDateFormat(phpFormat) : DEFAULT_DATE_FORMAT;
    });
  }
}
